import { render, staticRenderFns } from "./definition.vue?vue&type=template&id=1afd1c32&"
import script from "./definition.vue?vue&type=script&lang=js&"
export * from "./definition.vue?vue&type=script&lang=js&"
import style0 from "./definition.vue?vue&type=style&index=0&id=1afd1c32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports